<template>
  <svg
    :class="customStyle"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 0.5C18.3513 0.5 23.5 5.64873 23.5 12C23.5 18.3513 18.3513 23.5 12 23.5C5.64873 23.5 0.5 18.3513 0.5 12C0.5 5.64873 5.64873 0.5 12 0.5Z"
      stroke="#128C8C"
    />
    <path
      d="M17.3578 7.6875H16.4216C16.2904 7.6875 16.1658 7.74777 16.0855 7.85089L10.5636 14.846L7.91581 11.4911C7.87576 11.4402 7.82471 11.3991 7.76648 11.3708C7.70826 11.3425 7.64439 11.3278 7.57965 11.3277H6.64349C6.55376 11.3277 6.50421 11.4308 6.55912 11.5004L10.2274 16.1478C10.3989 16.3647 10.7283 16.3647 10.9011 16.1478L17.4422 7.85893C17.4971 7.79063 17.4475 7.6875 17.3578 7.6875Z"
      fill="#128C8C"
    />
  </svg>
</template>

<script>
export default {
  name: 'TickGreenIcon',

  props: {
    customStyle: {
      type: String,
      default: 'h-4 w-4',
    },
  },
}
</script>
